import OverlappingDonutChart from "./overlapping_donut_chart";
import { Box } from "@arise-biodiversity/components";

export default function TableChart({ data }) {
    return (
        <Box>
            <div>
                <h3>{data.taxon}</h3>
                <p className="table-chart-text text-small gray mb-0">
                    {data.rank}
                    <br />
                    Total coverage: {data.total}%
                </p>
                {data.rank === "species" ? (
                    <p className="table-chart-text">
                        References of species {data.taxon}
                    </p>
                ) : (
                    <p className="table-chart-text">
                        References of species belonging to the {data.rank} {data.taxon}
                    </p>
                )}
            </div>
            <div className="table-chart">
                <OverlappingDonutChart
                    size={180}
                    arisePercent={data.arise}
                    otherPercent={data.other}
                    totalPercent={data.total}
                />
            </div>
            <div>
                <h4 className="table-chart-value arise mt-4">{data.arise}% ARISE</h4>
                <p className="table-chart-text text-small subtitle mb-3">
                    Of which <strong>{data.uniqueArisePercent}%</strong> uniquely
                    covered by ARISE
                </p>
                <h4 className="table-chart-value other mb-3">
                    {data.other}% Other organizations
                </h4>
                <h4 className="table-chart-value shared">{data.shared}% Shared data</h4>
            </div>
        </Box>
    );
}